/*
  sov — move native inbox toggle into placeholder (no clones)

  Funzione:
  - Nasconde subito il toggle nativo per evitare flicker.
  - Se esiste un placeholder [data-sov-inbox-slot], sposta lì il *vero* bottone nativo.
  - Lascia invariata tutta la UI/overlay della chat dentro lo shadowRoot.
  - Aggiunge un fallback di apertura via is-open nel caso la versione dell’app usi delega eventi.

  Ultimo aggiornamento: 2025-10-15 19:25 (Europe/Rome)
*/
(function () {
	/* sov — forza chat chiusa a ogni page load e prima di lasciare la pagina */
(function () {
  
  // if (!/\/(?:[a-z]{2}-[a-z]{2}\/)?pages\/contact(?:\/|$)/i.test(location.pathname)) return;

  function forceClosed() {
    try {
      var raw = localStorage.getItem('shopifyChatData');
      var data = raw ? JSON.parse(raw) : {};
      if (!data || typeof data !== 'object') data = {};
      if (data.isOpen !== false) {
        data.isOpen = false;
        localStorage.setItem('shopifyChatData', JSON.stringify(data));
      }
    } catch (e) { /* no-op */ }
  }

  // 1) Chiudi subito (prima che il widget legga lo storage)
  forceClosed();

  // 2) Chiudi quando l’utente ricarica/abbandona (copre refresh senza premere la X)
  addEventListener('pagehide', forceClosed, { passive: true });
  addEventListener('beforeunload', forceClosed, { passive: true });
})();
	/* marca lo stato montato: il CSS rimuove il pre-hide dell'host */
function markMounted() {
	document.documentElement.classList.add('sov-inbox-mounted');
}
/* rimuove il mark quando non c'è slot (host resta nascosto) */
function unmarkMounted() {
	document.documentElement.classList.remove('sov-inbox-mounted');
}
	/* selettori base */
	function getHost() { return document.getElementById('ShopifyChat'); }
	function getRoot() { var h = getHost(); return (h && h.shadowRoot) ? h.shadowRoot : null; }
	function getNativeToggle() {
		var r = getRoot();
		if (!r) return null;
		return r.querySelector('[data-spec="toggle-button"]') || r.querySelector('.chat-toggle');
	}
	function getSlot() { return document.querySelector('[data-sov-inbox-slot]'); }
	
	/* sov — gtag per eventi nominati dal placeholder
   Crea un event name del tipo "<nome>_<azione>", es. "pdp_primary_click".
   Se il nome non è valido, viene sanificato (lowercase, non alfanumerici → _). */
function sovGtagByName(action) {
	var slot = document.querySelector('[data-sov-inbox-slot]');
	if (!slot || typeof window.gtag !== 'function') return;

	var raw = slot.getAttribute('data-sov-inbox-name') || '';
	var name = raw.toLowerCase().replace(/[^a-z0-9_]/g, '_');
	if (!/^[a-z]/.test(name)) name = 'sov_' + name; /* GA4 richiede lettera iniziale */

	var eventName = name + '_' + action; /* es: pdp_primary_click */
	window.gtag('event', eventName, {
		page_location: location.href,
		page_title: document.title
	});
}


	/* riconoscimento pulsanti di chiusura (mobile + desktop) */
function isCloseButton(el) {
	if (!el) return false;
	/* mobile: name="closeChat" */
	if (el.getAttribute && el.getAttribute('name') === 'closeChat') return true;
	/* desktop: .chat-app--close-button */
	if (el.classList && el.classList.contains('chat-app--close-button')) return true;
	return false;
}

/* retry brevi post-chiusura per coprire re-render del toggle sticky */
function scheduleReposition() {
	var delays = [40, 140, 300, 600, 1000];
	for (var i = 0; i < delays.length; i++) {
		setTimeout(function () { runOnce(); }, delays[i]);
	}
}

/* bind una sola volta dentro lo shadowRoot: intercetta la X e rilancia i retry */
function bindCloseReposition() {
	var root = getRoot();
	if (!root || root.__sovCloseBound) return;

	root.addEventListener('click', function (ev) {
		/* percorre il composedPath dello shadow, copre mobile e desktop */
		var path = (ev.composedPath && ev.composedPath()) || [ev.target];
		for (var i = 0; i < path.length; i++) {
			if (isCloseButton(path[i])) {
				try { sovGtagByName('close'); } catch (e) {}
				scheduleReposition();
				break;
			}
		}
	}, true); /* capture per sicurezza nello shadow */

	root.__sovCloseBound = true;
}


	/* nasconde il toggle per evitare qualsiasi flash in basso a destra */
	function hardHideToggle(t) {
		if (!t) return;
		t.style.removeProperty('opacity');  
		t.style.display = 'none';
		t.style.visibility = 'hidden';
		t.style.opacity = '0';
		t.style.pointerEvents = 'none';
		t.setAttribute('data-sov-hidden', '1');
	}

	/* normalizza il bottone per uso “in-flow” nello slot */
	function normalizeToggleLook(t) {
		if (!t) return;
		/* rimozione classi che impongono sticky o mobile-only */
		try { t.classList.remove('chat-toggle','chat-toggle--bottom-right', 'mobile-only'); } catch (e) {}

		/* stile minimo per renderlo un bottone standard, senza layout fixed */
		t.style.position = 'static';
		t.style.margin = '0';
		t.style.display = 'inline-flex';
		t.style.visibility = 'visible';
		/*t.style.opacity = '1';*/
		t.style.pointerEvents = 'auto';
		t.removeAttribute('data-sov-hidden');
	}
/* sov — append etichetta al bottone nello slot
   Descrizione: legge data-sov-inbox-label dallo slot e appende <span class="sov-inbox-label">…</span>
   Ultimo aggiornamento: 2025-10-15 21:18 (Europe/Rome)
   Prima: nessuna etichetta custom appesa.
   Dopo: etichetta custom appesa in coda al bottone. */
function appendSlotLabel() {
	var slot = document.querySelector('[data-sov-inbox-slot]');
	if (!slot) return;

	var label = slot.getAttribute('data-sov-inbox-label');
	if (!label) return;

	/* trova il bottone già spostato nello slot */
	var btn = slot.querySelector('[data-spec="toggle-button"], .chat-toggle, button');
	if (!btn) return;

	/* evita duplicazioni: crea se non esiste */
	var existing = btn.querySelector('.sov-inbox-label');
	if (!existing) {
		existing = document.createElement('span');
		existing.className = 'sov-inbox-label';
		btn.appendChild(existing);
	}

	existing.textContent = label;
}

	/* sposta il bottone nativo nello slot (nessun clone) */
	function placeToggleIntoSlot() {
		var slot = getSlot();
		var t = getNativeToggle();
		if (!slot || !t) return false;

		/* 1) nascondi per evitare flicker mentre si reparenta */
		hardHideToggle(t);

/* 2) append nello slot (spostamento reale del nodo) */
try { slot.appendChild(t); } catch (e) { return false; }

/* 3) normalizza aspetto e prepara fade-in */
normalizeToggleLook(t);
appendSlotLabel(); /* aggiunge testo custom al bottone nello slot */
t.classList.add('sov-inbox-fade-in');

/* 4) ri-mostra con transizione nel frame successivo */
requestAnimationFrame(function () {
		t.style.visibility = 'visible';
	t.style.opacity = '1';
});

/* 5) assicura il riposizionamento automatico alla chiusura */
bindCloseReposition();

/* 6) sblocca il gate CSS: l'host torna visibile per l'overlay */
markMounted();

		/* 4) fallback apertura: se la delega eventi non segue il nodo spostato,
		      forzare is-open=true sull'host quando viene cliccato */
		if (!t.__sovFallbackBound) {
			t.addEventListener('click', function () {
				sovGtagByName('open');
				var host = getHost();
				if (host) {
					try { host.setAttribute('is-open', 'true'); } catch (e) {}
				}
			});
			t.__sovFallbackBound = true;
		}
		return true;
	}

	/* esecuzione leggera: attende host + shadow + toggle, poi una sola corsa */
function runOnce() {
	var host = getHost();
	var root = getRoot();
	var t = getNativeToggle();

	/* bind del riposizionamento alla chiusura, appena lo shadowRoot esiste */
	if (root) {
		bindCloseReposition();
	}

	/* se non c'è slot → nascondere il toggle sticky e tenere l'host pre-hidato */
	if (!getSlot()) {
		if (t) hardHideToggle(t);
		unmarkMounted(); /* mantiene l'host opaco: nessun flicker, nessun sticky */
		return !!(host && root && t);
	}

	/* con slot presente → spostare il bottone dentro lo slot */
	if (host && root && t) {
		return placeToggleIntoSlot(); /* dentro: markMounted() e fade-in */
	}

	return false;
}



	/* boot: polling breve, poi si ferma */
	(function boot() {
		var waited = 0, POLL = 50, MAX = 6000;
		var iv = setInterval(function () {
			if (runOnce() || waited >= MAX) clearInterval(iv);
			waited += POLL;
		}, POLL);
	})();

	/* ri-esegue quando si rientra dalla cache o si ricaricano sezioni */
	window.addEventListener('pageshow', runOnce, { passive: true });
	document.addEventListener('shopify:section:load', runOnce, { passive: true });

	/* espone funzione riutilizzabile (manuale) */
	window.sovPlaceInboxToggle = runOnce;
})();
/* sov — inbox: viewport listeners per re-normalizzare il toggle nello slot
   Rimuove classi sticky reintrodotte dal widget su resize/orientation.
   Ultimo aggiornamento: 2025-10-15 20:25 (Europe/Rome) */
/* sov — resize: riapplica classi e fade con piccoli retry */
(function () {
	function getSlotToggle() {
		var slot = document.querySelector('[data-sov-inbox-slot]');
		if (!slot) return null;
		return slot.querySelector('[data-spec="toggle-button"], .chat-toggle, button');
	}
	function restartFade(el) {
		if (!el) return;
		el.classList.remove('sov-inbox-fade-in');
		void el.offsetWidth; /* reflow */
		el.classList.add('sov-inbox-fade-in');
	}
	function renormalizeOnce() {
		var t = getSlotToggle();
		if (!t) return false;
		try {
			t.classList.remove(
				'chat-toggle',
				'chat-toggle--bottom-right',
				'mobile-only',
				'chat-toggle--text-button',
				'chat-toggle--icon-button'
			);
		} catch (e) {}
		if (typeof appendSlotLabel === 'function') { appendSlotLabel(); }
		restartFade(t);
		return true;
	}
	function applyAfterResize() {
		if (renormalizeOnce()) return;
		requestAnimationFrame(function () {
			if (renormalizeOnce()) return;
			setTimeout(renormalizeOnce, 80);
		});
	}

	window.addEventListener('resize', applyAfterResize, { passive: true });
	window.addEventListener('orientationchange', applyAfterResize, { passive: true });
	try {
		var mq = window.matchMedia('(max-width: 749px)');
		var h = applyAfterResize;
		if (mq.addEventListener) mq.addEventListener('change', h);
		else if (mq.addListener) mq.addListener(h);
	} catch (e) {}
})();

